import zhCN from './zh-CN.json'
import enUS from './en-US.json'

export const DEFAULT_LOCALE = 'zh-CN'
export const FALLBACK_LOCALE = 'zh-CN'

export const messages = {
  'zh-CN': zhCN,
  'en-US': enUS
}

export function getStoredLocale() {
  return localStorage.getItem('locale') || DEFAULT_LOCALE
}

export function syncHtmlLang(locale) {
  document.documentElement.lang = locale === 'en-US' ? 'en' : 'zh-CN'
}



// WEBPACK FOOTER //
// ./src/locales/index.js